<template>
<div class="chapter">
<div class="inner_page">
<p class="p11"><img alt="img4.jpg" height="280" src="images/img4.jpg" width="420"/></p>
<p class="p11"><span class="t13">Photo by David Schmidt</span></p>
<p class="p12">to Dunkyn and Dolan</p>
<p class="p0">thank you for sharing your lives with me</p>
<p class="p0">and making mine so much better</p>
<p class="p3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?500854d2